export default "/static/images/tuut_1.png?a821f53f2f12265d1bb8e5ff81b82ead";